import React from 'react';
import { LuNetwork } from 'react-icons/lu';

import { Card, CardHeader, CardTitle } from '@/components/ui/card';
import { formatCurrency } from '@/utils/number-formatter';
import { cn } from 'utils/cn';
import { AccountsTable } from 'views/household/OverviewTab/components/AccountsTable';
import { useAccountGroupProfileWithAumIncluded } from 'views/portfolio/account-aum-queries';

interface AccountsCardProps {
    accountGroupGUID: string;
    className?: string;
}

export const AccountsCard = ({ accountGroupGUID, className }: AccountsCardProps) => {
    const {
        data: accountGroupProfileWithAumIncluded,
        isPending: isLoadingAccountGroupProfile,
        isFetching: isFetchingAccountGroupProfile,
    } = useAccountGroupProfileWithAumIncluded(accountGroupGUID);

    const accounts = accountGroupProfileWithAumIncluded?.accounts || [];
    const totalBalance = accountGroupProfileWithAumIncluded?.accountGroup.aum;

    return (
        <Card className={cn(className, 'rounded-t-xl')}>
            <CardHeader className="rounded-t-xl bg-[#B6E3C0] pt-2 pb-2">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <LuNetwork className="h-5 w-5 text-black" />
                        <div className="leading-tight">
                            <CardTitle className="text-lg leading-tight font-semibold text-black">Accounts</CardTitle>
                            <div className="text-xs leading-tight text-gray-600">
                                {accounts.length} account{accounts.length !== 1 ? 's' : ''}
                            </div>
                        </div>
                    </div>
                    <div className="font-mono text-sm font-semibold text-black">{formatCurrency(totalBalance)}</div>
                </div>
            </CardHeader>
            <div className="pt-2 pr-6 pb-6 pl-6">
                {isLoadingAccountGroupProfile || isFetchingAccountGroupProfile ? (
                    <div className="flex items-center justify-center py-8">
                        <div className="flex flex-col items-center gap-3">
                            <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-gray-900"></div>
                            <span className="text-sm text-gray-600">Loading...</span>
                        </div>
                    </div>
                ) : accountGroupProfileWithAumIncluded ? (
                    <AccountsTable
                        accountGroupProfileWithAumIncluded={accountGroupProfileWithAumIncluded}
                        showAccountOwnerColumn={false}
                        disableDrag={true}
                    />
                ) : null}
            </div>
        </Card>
    );
};
